module.exports = __webpack_public_path__ + "media/vuesrc/apps/public/images/about/coins-e6986dab9edebbccc3896dfd16aecce3.png";